import Vue from "vue";
import Router from "vue-router";
import Videos from "./views/Videos.vue";
import APK from "./views/APK.vue";
import AddVideo from "./views/AddVideo.vue";
import EditVideo from "@/components/EditVideo.vue";
import AddAPK from "@/components/AddAPK.vue";
import Devices from "./views/Devices.vue";
import Login from "./views/Login.vue";
import Merchants from "./views/Merchants.vue";
import MerchantTable from "./views/MerchantTable.vue";
// import Transactions from "./views/Transactions.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/videos",
      name: "videos",
      component: Videos
    },
    {
      path: "/apk",
      name: "apk",
      component: APK
    },
    {
      path: "/add-video",
      name: "add-video",
      component: AddVideo
    },
    {
      path: "/edit-video",
      name: "edit-video",
      component: EditVideo
    },
    {
      path: "/devices",
      name: "devices",
      component: Devices
    },
    {
      path: "/devices/:device_id/",
      name: "devices-modal",
      component: Devices
    },
    {
      path: "/add-apk",
      name: "add-apk",
      component: AddAPK
    },
    {
      path: "/merchants",
      name: "merchants",
      component: Merchants
    },
    {
      path: "/merchant_table",
      name: "merchant_table",
      component: MerchantTable
    }
  ]
});